import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { TranslationFunction } from '@/app/components/translations/Translation';
import type { ControlProps } from '@/app/components/search/components/Form';
import FilterContainer from '../FilterContainer';
import getRadioContainer from './getRadioContainer';
import type { CommonProps } from './CommonProps';

type GetClimateField = {
  searchParams: SearchParams;
  commonProps: CommonProps;
  t: TranslationFunction;
};

export const getClimateOptions = ({ t }: { t: TranslationFunction }) => [
  { value: 0, label: t('vacation.oss.filters.climate.all'), selectedClassName: '' },
  { value: 1, label: t('vacation.oss.filters.climate.tropical'), selectedClassName: '' },
  { value: 2, label: t('vacation.oss.filters.climate.subtropical'), selectedClassName: '' },
  { value: 3, label: t('vacation.oss.filters.climate.equatorial'), selectedClassName: '' },
  { value: 4, label: t('vacation.oss.filters.climate.subequatorial'), selectedClassName: '' },
];

const getClimateField = ({ t, searchParams, commonProps }: GetClimateField): ControlProps =>
  getRadioContainer({
    fieldName: URLParameters.CLIMATE,
    containerTitle: t('vacation.oss.filters.climate.title'),
    containerName: FilterContainer.ClimateContainer,
    options: getClimateOptions({ t }),
    value: searchParams[URLParameters.CLIMATE] ? parseInt(searchParams[URLParameters.CLIMATE], 10) : 0,
    ...commonProps,
  });

export default getClimateField;
